import { Nullable } from 'models/helpers'

/** What a submit did to the creative's saved comment; `sent` null means the backend kept the saved one */
export const creativeCommentOutcome = (saved: Nullable<string>, sent: Nullable<string>) => {
  if (sent == null || sent === (saved ?? '')) return saved ? 'kept_saved' : 'none'
  if (!sent) return 'cleared_saved'
  return 'edited'
}
